import { api, ApiOptions, mBaseURL } from "@/config/api";
import { unwrapApiError } from "@/lib/error";
import { createURLPath } from "@/lib/utils";

export const ResearchApiFactory = {
  Endpoint: mBaseURL + "/api/research",
  Schemas: {},
  Apis: {
    ConsumeBrandResearch: async (stream: string, options?: ApiOptions) => {
      const response = await api(createURLPath(ResearchApiFactory.Endpoint, "brand", stream), {
        method: "GET",
        ...(options || {}),
      });

      if (!response.ok || !response.body) {
        const error = await response.json().catch(() => ({ message: "Oops, something went wrong! Please try again." }));
        throw new Error(unwrapApiError(error));
      }

      return response.body;
    },
  },
};
